import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';

export const communicationHubRoute: Route = {
  path: 'communication-hub',
  canActivate: [PermissionGuard],
  data: {
    permissions: [
      Permission.OPERATIONS_ONBOARDING,
      Permission.ONBOARDING_IFA,
      Permission.ONBOARDING_FRONT_OFFICE,
      Permission.ADMIN,
      Permission.CLIENT_ADMIN,
      Permission.PORTFOLIO_MANAGER,
      Permission.PORTFOLIO_ASSISTANT,
      Permission.CLIENT,
      Permission.IFA_ADVISOR,
      Permission.IFA_ASSISTANT,
      Permission.IFA_CORPORATE_ADMIN,
      Permission.CASE_REVIEW,
    ],
  },
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    {
      path: 'list',
      canActivate: [PermissionGuard],
      data: {
        permissions: [
          Permission.OPERATIONS_ONBOARDING,
          Permission.ONBOARDING_IFA,
          Permission.ONBOARDING_FRONT_OFFICE,
          Permission.ADMIN,
          Permission.CLIENT_ADMIN,
          Permission.PORTFOLIO_MANAGER,
          Permission.PORTFOLIO_ASSISTANT,
        ],
      },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./communication-hub.component').then((c) => c.CommunicationHubComponent),
        },
        {
          path: ':id',
          loadComponent: () =>
            import('./details/details.component').then((c) => c.CommunicationHubDetailsComponent),
        },
      ],
    },
    {
      path: 'my-messages',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.CLIENT] },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./my-messages/my-messages.component').then((c) => c.MyMessagesComponent),
        },
        {
          path: ':id',
          loadComponent: () =>
            import('./details/details.component').then((c) => c.CommunicationHubDetailsComponent),
        },
      ],
    },
    {
      path: 'ifa',
      canActivate: [PermissionGuard],
      data: {
        permissions: [
          Permission.ONBOARDING_IFA,
          Permission.IFA_ADVISOR,
          Permission.IFA_ASSISTANT,
          Permission.IFA_CORPORATE_ADMIN,
        ],
      },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./ifa-requests/ifa-requests.component').then((c) => c.IfaRequestsComponent),
        },
        {
          path: ':id',
          loadComponent: () =>
            import('./details/details.component').then((c) => c.CommunicationHubDetailsComponent),
        },
      ],
    },
    {
      path: 'team-review',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.CASE_REVIEW, Permission.ADMIN] },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./team-review/team-review.component').then((c) => c.TeamReviewComponent),
        },
        {
          path: ':id',
          loadComponent: () =>
            import('./details/details.component').then((c) => c.CommunicationHubDetailsComponent),
        },
      ],
    },
  ],
};
